import { ReferencedEntry } from 'contentful';
import React from 'react';

import { SpeedBumpList } from 'src/api/contentful/contentTypes.shop';
import { SHOPLESS_RESELLER_ID } from 'src/services/analytics/channelInfo';

import { useSalesChannel } from '../SalesChannel/SalesChannel';
import { SpeedbumpModal } from '../SpeedbumpModal/SpeedbumpModal';

export interface IShopbump {
  entry?: ReferencedEntry<SpeedBumpList>;
  children?: never;
}

export const Shopbump: React.FC<IShopbump> = ({ entry }) => {
  const { trackingHost } = useSalesChannel();

  return (!trackingHost || trackingHost === SHOPLESS_RESELLER_ID) ? <SpeedbumpModal isOpen entry={entry} /> : null;
};
